const e = {
  "@ado/acs-standard-library": {
    "loading-bar": {
      "loading-message": () => "Wir bereiten alles für Sie vor."
    },
    "contact-list": {
      "name-label": () => "Name",
      "email-label": () => "E-Mail-Adresse"
    },
    "contact-validator": {
      "duplicate-contact-message": () => "Mitbenutzer bereits hinzugefügt",
      "maximum-recipients-message": () => "Empfängerlimit erreicht",
      "invalid-email-message": () => "Bitte geben Sie eine gültige E-Mail-Adresse ein",
      "invalid-name-message": () => "Bitte geben Sie einen Namen ein"
    },
    "invitation-dialog": {
      "send-invite": () => "Einladung Senden"
    }
  }
};
export {
  e as default
};
//# sourceMappingURL=index.js.map
